/**
 * Caminho para ficheiros em `public/` quando o admin está servido em `/admin/*` (produção).
 * Um `src` absoluto na raiz (`/logo.png`) pede o domínio errado; o asset fica em `/admin/logo.png`.
 */
export function adminPublicPath(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (typeof window === 'undefined') return normalized;
  return window.location.pathname.startsWith('/admin') ? `/admin${normalized}` : normalized;
}
